export default __webpack_public_path__ + "static/media/benefit_2.ec5e1213.png";